import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import Swal from "sweetalert2";  

import "./profileupdate.css";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Header from "../../components/header/Header";
import Subscribe from "../../components/subscribe/Subscribe";
import Footer from "../../components/footer/Footer";
import { baseURL } from "../../constants/url";
import UploadIcon from "../../assets/images/user-profile-plus.jpg";

function ProfileUpdate() {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    profile_picture: null,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    const token = localStorage.getItem("authToken");

    if (!token || isTokenExpired(token)) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("user");
      navigate("/login");
      return;
    }

    if (storedUser) {
      const user = JSON.parse(storedUser);
      setFormData((prev) => ({
        ...prev,
        ...user,
      }));
    }

    
  }, [navigate]);

  // Floating labels setup
    const inputs = document.querySelectorAll("input");
    inputs.forEach((input) => {
      if (input.value.trim() !== "") {
        input.classList.add("filled");
      }

      input.addEventListener("input", () => {
        if (input.value.trim() !== "") {
          input.classList.add("filled");
        } else {
          input.classList.remove("filled");
        }
      });
    });
    
  const isTokenExpired = (token) => {
    if (!token) return true;
    try {
      const decoded = jwtDecode(token);
      return decoded.exp < Date.now() / 1000;
    } catch (error) {
      return true;
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.first_name.trim()) newErrors.first_name = "First name is required.";
    if (!formData.last_name.trim()) newErrors.last_name = "Last name is required.";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid.";
    }
    if (!formData.phone_number.trim()) newErrors.phone_number = "Phone number is required.";
    return newErrors;
  };

  const handleChange = (e) => {
    let { name, value, files } = e.target;
    if (name === "phone_number") {
    value = value.replace(/\D/g, "").slice(0, 10);
  }
    if (name === "profile_picture") {
      setFormData({ ...formData, profile_picture: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  const validationErrors = validate();
  if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);
    return;
  }

  setLoading(true);

  try {
    const token = localStorage.getItem("authToken");
    if (!token || isTokenExpired(token)) {
      setLoading(false);
      navigate("/login");
      return;
    }

    const data = new FormData();
    data.append("first_name", formData.first_name);
    data.append("last_name", formData.last_name);
    data.append("email", formData.email);
    data.append("phone_number", formData.phone_number);

    //  profile_picture is optional
    if (formData.profile_picture && formData.profile_picture instanceof File) {
      data.append("profile_picture", formData.profile_picture);
    }

    const response = await axios.patch(`${baseURL}common/profile/`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.status === 200 || response.status === 201) {
      localStorage.setItem("user", JSON.stringify(response.data));

      Swal.fire({
        icon: "success",
        title: "Profile Updated",
        text: "Your profile was updated successfully!",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Ok",
      });

      setTimeout(() => {
        navigate("/profile");
      }, 1500);
    } else {
      Swal.fire("Error", "Failed to update profile.", "error");
    }
  } catch (error) {
    console.error("Update error:", error);
    const errorMsg =
      error.response?.data?.detail ||
      error.response?.data?.message ||
      "Something went wrong while updating profile.";
    Swal.fire("Error", errorMsg, "error");
  } finally {
    setLoading(false);
  }
};


  return (
    <>
      <Header />
      <div className="container-fluid bg_gray">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 pt_30 pb_40 mt_30">
              <div className="profile_update pb_20">
                <div className="formContainer">
                  <div className="signInContainer">
                    <h4 className="form_title">Update Profile</h4>
                    <form onSubmit={handleSubmit}>
                      <div className="inputSection">
                        <input
                          type="text"
                          name="first_name"
                          value={formData.first_name}
                          onChange={handleChange}
                          className="userName"
                        />
                        {/* <label className="inputLabel">First Name</label> */}
                        {errors.first_name && <p className="formError">{errors.first_name}</p>}
                      </div>

                      <div className="inputSection">
                        <input
                          type="text"
                          name="last_name"
                          value={formData.last_name}
                          onChange={handleChange}
                          className="userName"
                        />
                        {/* <label className="inputLabel">Last Name</label> */}
                        {errors.last_name && <p className="formError">{errors.last_name}</p>}
                      </div>

                      <div className="inputSection">
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          className="userName pl_10"
                        />
                        {/* <label className="inputLabel">Email</label> */}
                        {errors.email && <p className="formError">{errors.email}</p>}
                      </div>

                      <div className="inputSection">
                        <input
                          type="text"
                          name="phone_number"
                          value={formData.phone_number}
                          onChange={handleChange}
                          className="userName"
                          maxLength={10}
                        />
                        {/* <label className="inputLabel">Phone Number</label> */}
                        {errors.phone_number && <p className="formError">{errors.phone_number}</p>}
                      </div>

                      <div className="inputSection">
                        <label className="upload-box" id="uploadLabel">
                          <span className="upload-placeholder" id="placeholder">
                            <img src={UploadIcon} width="30" alt="upload" />
                          </span>
                          <input
                            type="file"
                            name="profile_picture"
                            accept="image/*"
                            onChange={handleChange}
                          />
                        </label>
                      </div>

                      <button className="saveForm" type="submit" disabled={loading}>
                        {loading ? "Updating..." : "Update"}
                      </button>
                    </form>

                    <div className="pr_20 pl_20 pb_15 mt_30 d_flex justify_sp_between">
                      <Link to="/" className="font_13 common_color d_flex align_center">
                       <ArrowBackIosIcon  className="icon_width_12" /> Back to Home
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Subscribe />
      <Footer />
    </>
  );
}

export default ProfileUpdate;
